import { TextInput } from "@mantine/core";
import { isNotEmpty } from "@mantine/form";
import {
  BaseRecord,
  HttpError,
  IResourceComponentsProps,
  ParsedParams,
  useGo,
  useParsed,
} from "@refinedev/core";
import { Create, useForm } from "@refinedev/mantine";
import ImageDropZone from "components/common/ImageDropZone";
import { CreatePollOption } from "entities/poll_option";

export const PollOptionCreate: React.FC<IResourceComponentsProps> = () => {
  const urlData = useParsed();
  const { poll_id } = urlData.params as ParsedParams<{ poll_id: string }>;
  const go = useGo();

  const { getInputProps, saveButtonProps, setFieldValue, values } = useForm<
    BaseRecord,
    HttpError,
    CreatePollOption
  >({
    initialValues: {
      label: "",
      image: undefined,
      poll_id: poll_id,
    },
    validate: {
      label: isNotEmpty(),
    },
    refineCoreProps: {
      redirect: false,
      onMutationSuccess: () =>
        go({ to: `/polls/show/${poll_id}`, type: "push" }),
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <ImageDropZone
        onFileChosen={(image) => setFieldValue("image", image)}
        value={null}
      />
      <TextInput label="Label" {...getInputProps("label")} />
    </Create>
  );
};
